(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["napoleonne-product"] && !Shopify.designMode) return;
  try {
    
const initNpPdp=(scope=document)=>{scope.querySelectorAll('[data-pdp]').forEach(root=>{
 if(root.dataset.initialized)return;root.dataset.initialized='true';
 const form=root.querySelector('form'),slides=[...root.querySelectorAll('[data-slide]')],thumbs=[...root.querySelectorAll('[data-thumb]')];
 const format=c=>new Intl.NumberFormat('fr-FR',{style:'currency',currency:root.dataset.currency}).format(c/100);
 const variant=()=>root.querySelector('[data-variant]:checked')||root.querySelector('[data-variant][type="hidden"]');
 let current=Math.max(0,slides.findIndex(s=>!s.hidden));
 const show=index=>{if(!slides.length)return;current=(index+slides.length)%slides.length;slides.forEach((s,i)=>s.hidden=i!==current);thumbs.forEach(t=>t.setAttribute('aria-pressed',String(t.dataset.image===slides[current].dataset.image)));root.querySelector('[data-counter]').textContent=(current+1)+' / '+slides.length;};
 const update=()=>{const v=variant();if(!v)return;const price=Number(v.dataset.price),q=Number(root.querySelector('[data-qty]:checked')?.value||1),total=Math.round(price*q*(q === 3 ? .85 : q === 2 ? .9 : 1)),available=v.dataset.available==='true';root.querySelector('[data-price]').textContent=format(price);root.querySelectorAll('[data-offer-price]').forEach(el=>{const n=Number(el.dataset.offerPrice);el.textContent=format(Math.round(price*n*(n === 3 ? .85 : n === 2 ? .9 : 1)));});root.querySelectorAll('[data-saving]').forEach(el=>{const n=Number(el.dataset.saving);el.textContent=format(price*n-Math.round(price*n*(n===3?.85:.9)));});root.querySelector('[data-mix]').disabled=!available;root.querySelector('[data-total]').textContent=format(total);root.querySelector('[data-sticky-total]').textContent=format(total);const label=available?root.dataset.add:root.dataset.sold;root.querySelector('[data-atc-label]').textContent=label;root.querySelector('[data-atc]').disabled=!available;root.querySelector('[data-sticky-atc]').disabled=!available;root.querySelector('[data-sticky-atc]').textContent=label;};
 thumbs.forEach(t=>t.addEventListener('click',()=>show(slides.findIndex(s=>s.dataset.image===t.dataset.image))));root.querySelector('[data-prev]').addEventListener('click',()=>show(current-1));root.querySelector('[data-next]').addEventListener('click',()=>show(current+1));
 form.addEventListener('change',e=>{update();if(e.target.matches('[data-variant]')){const v=variant(),i=slides.findIndex(s=>s.dataset.image===v.dataset.image);if(i>=0)show(i);const url=new URL(location.href);url.searchParams.set('variant',v.value);history.replaceState(null,'',url);}});
 root.querySelector('[data-mix]').addEventListener('click',async()=>{const button=root.querySelector('[data-mix]'),status=root.querySelector('[data-mix-status]');if(button.disabled)return;button.disabled=true;button.textContent=root.dataset.mixBusy;status.hidden=true;try{const body=new FormData(form);body.set('quantity','1');const response=await fetch(root.dataset.cartAdd+'.js',{method:'POST',body,headers:{Accept:'application/json'}});if(!response.ok)throw Error('cart');await response.json();location.assign(root.dataset.collection);}catch(error){status.hidden=false;status.textContent=root.dataset.mixError;button.textContent=root.dataset.mixLabel+' →';update();}});
 root.querySelector('[data-sticky-atc]').addEventListener('click',()=>form.requestSubmit(root.querySelector('[data-atc]')));
 const syncSticky=()=>{root.querySelector('[data-sticky]').hidden=root.querySelector('[data-atc]').getBoundingClientRect().bottom>0;};let scrollPending=false;window.addEventListener('scroll',()=>{if(scrollPending)return;scrollPending=true;requestAnimationFrame(()=>{syncSticky();scrollPending=false;});},{passive:true});window.addEventListener('resize',syncSticky);syncSticky();
 let sx=0;root.querySelector('.np-gallery__stage').addEventListener('touchstart',e=>sx=e.changedTouches[0].clientX,{passive:true});root.querySelector('.np-gallery__stage').addEventListener('touchend',e=>{const dx=e.changedTouches[0].clientX-sx;if(Math.abs(dx)>55){show(current+(dx<0?1:-1));}},{passive:true});
 show(current);update();
});};
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initNpPdp());else initNpPdp();
document.addEventListener('shopify:section:load',e=>initNpPdp(e.target));

  } catch(e) { console.error(e); }
})();
})();
